import axiosApiInstance from "../../interceptors/axiosApiInstance";
import { BASE_URL } from "../config";


const DashBoardService = {
    getDashboards: async function () {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/dashboard/list`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getDashboardById: async function (id) {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/dashboard/${id}`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    updateDashboardDate: async function (id, data) {
        try {
            const response = await axiosApiInstance.put(
                await BASE_URL + `/dashboard/${id}/date`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getQuickInformations: async function () {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/dashboard/quickview`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getDashBoardReports: async function () {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/dashboard/reports`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getDashBoardReportDetail: async function (id) {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/dashboard/report/${id}`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getCharts: async function () {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/dashboard/charts`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getWidgetById: async function (id) {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/dashboard/widget/${id}`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getWidgetDataById: async function (id, data) {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/dashboard/widget/${id}/dataset`,
                { params: data }
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    createWidget: async function (data) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + `/dashboard/widget`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    createDashBoard: async function (data) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + `/dashboard`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    updateWidget: async function (id, data) {
        try {
            const response = await axiosApiInstance.put(
                await BASE_URL + `/dashboard/widget/${id}`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    deleteDashboard: async function (id) {
        try {
            const response = await axiosApiInstance.delete(
                await BASE_URL + `/dashboard/${id}`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    deleteWidget: async function (id, params) {
        try {
            const response = await axiosApiInstance.delete(
                await BASE_URL + `/dashboard/widget/${id}`,
                params
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    updateWidgetOrders: async function (data) {
        try {
            const response = await axiosApiInstance.put(
                await BASE_URL + `/dashboard/widget/change/orders`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
}

export default DashBoardService;